<template>
  <div>
   
  <div v-if="UserForms && UserForms.length">
    <el-table :data="UserForms">
      <el-table-column prop="date1" label="日期" style="width: 4%;"  :formatter="formatDate"> </el-table-column>
      <el-table-column prop="ghxh" label="学号/工号" style="width: 3%;"> </el-table-column>
      <el-table-column prop="name" label="姓名" style="width: 3%;"> </el-table-column>
      <el-table-column prop="phone" label="手机号" style="width: 4%;"> </el-table-column>
      <el-table-column prop="idc" label="身份证号" style="width: 6%;"> </el-table-column>
      <el-table-column prop="sex" label="性别" style="width: 3%;"> </el-table-column>
      <el-table-column prop="fenlei" label="人员分类" style="width: 5%;"> </el-table-column>
      <!-- 新增的人脸数据列 -->
      <el-table-column prop="faceData" label="人脸数据" style="width: 5%;">
        <template slot-scope="scope">
          <img
            v-if="scope.row.faceData"
            :src="scope.row.faceData"
            style="width: 100px; height: 100px"
          />
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" style="width: 10%;">
        <template slot-scope="scope">
          <el-button @click="edit(scope.row._id)" type="text" size="small">编辑</el-button>
          <el-button @click="remove(scope.row._id)" type="text" size="small">删除</el-button>
          <el-button @click="setAsAdmin(scope.row._id)" type="text" size="small">设置为管理员</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
  <div v-else>
    <p>没有数据可用。</p>
  </div>
  <div >
      <footers/>
    </div>
</div>
</template>

<script>
import footers from '../components/footer.vue'
export default {
  components: {   
    footers
  },
  data() {
    return {
      UserForms: [], // 存储人员信息列表
      userInfo: null,
    };
  },
  methods: {
    fetchUserForms() {
      this.$http
        .get("UserForm")
        .then((res) => {
          if (res&& Array.isArray(res)) {
            this.UserForms = res; // 更新 UserForms 数据
          } else {
            console.error('API 返回的数据格式不正确:', res);
          }
        })
        .catch((err) => {
          console.error("获取人员列表失败:", err);
        });
    },
    remove(id) {
      if (!id) {
        this.$message.error("无效的人员 ID");
        return;
      }
      this.$http
        .delete(`UserForm/${id}`)
        .then((res) => {
          this.$message({
            message: "人员删除成功",
            type: "success",
          });
          this.fetchUserForms();
        })
        .catch((error) => {
          console.error("删除人员失败:", error);
          this.$message.error("人员删除失败，请重试");
        });
    },
    edit(id) {
      if (!id) {
        this.$message.error("无效的人员 ID");
        return;
      }
      this.$router.push(`/user/${id}/edit`);
    },
    setAsAdmin(id) {
      this.$http
        .post(`/UserForm/setAdmin/${id}`)
        .then((res) => {
          this.$message({
            message: "设置管理员成功",
            type: "success",
          });
          // 重新获取用户列表数据，更新 UserList.vue 组件
          this.fetchUserForms();
          this.$router.push(`/user-setting/${id}`); // 传递人员ID
        })
        .catch((err) => {
          console.error("设置管理员失败:", err);
          this.$message.error("设置管理员失败，请重试");
        });
    },
    formatDate(row, column, cellValue) {
      const date = new Date(cellValue);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    }

  },
  created() {
    this.fetchUserForms();
  }
};
</script>